import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { CalendarArrow } from "@/Components/Icons/CalendarArrow";
import {
  setShowProfile,
  updateActiveDetailListing,
} from "@/reducers/clientcandidatedetail";
/**
 * Return the detail section tabs component.
 *
 * @return {JSX.Element} The detail section tabs component.
 */
const DetailSectionTabs = () => {
  const { activeDetailListing, showProfile } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  const clientUserAllPermissions = useSelector(
    (state) => state.session.clientUserAllPermissions,
  );
  const canViewCompliance =
    clientUserAllPermissions?.is_allow_to_view_download_compliance !== 0;
  const dispatch = useDispatch();
  const listingArr = [
    {
      name: "Profile Information",
      type: "canProfileInfo",
    },
    {
      name: "Upcoming Shifts",
      type: "upcomingShifts",
    },
    {
      name: "Work History",
      type: "workHistory",
    },
    ...(canViewCompliance
      ? [
          {
            name: "Compliance",
            type: "compliance",
          },
        ]
      : []),
  ];
  return (
    <div className={`DetailSectionTabs_Wrapper`}>
      <button
        className={`absolute top-12 grid h-[32px] w-[32px] -translate-x-1/2 place-items-center rounded-2xl bg-white text-center shadow-lg ${!showProfile ? "left-0" : "-left-4"}`}
        onClick={() => {
          dispatch(setShowProfile(!showProfile));
        }}
      >
        <CalendarArrow
          cls={`transition-linear w-auto h-[15px] ${showProfile ? "text-primary" : "text-primary rotate-180"}`}
        />
      </button>
      <div
        className={`my-[13px] grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-6 md:grid-cols-3 lg:grid-cols-4 ${showProfile ? "pl-3 md:pl-6" : ""}`}
      >
        {listingArr.map((item, index) => (
          <div
            className="flex cursor-pointer flex-col gap-2"
            key={index}
            onClick={() => {
              dispatch(updateActiveDetailListing(item.type));
              dispatch(setShowProfile(!(item.type == "canProfileInfo")));
            }}
          >
            <div
              className={`flex items-center gap-[6px] ${showProfile ? "min-w-[169px]" : "max-w-[169px]"}`}
            >
              <span
                className={`${
                  activeDetailListing === item.type
                    ? "text-txtDark"
                    : "text-txtColor"
                } transition-linear line-clamp-1 text-[14px] font-semibold`}
              >
                {item.name}
              </span>
            </div>
            <div
              className={`before:transition-linear relative h-[5px] w-full overflow-hidden rounded-[2px] bg-lightblue before:absolute before:h-full before:bg-primary before:content-[''] ${
                activeDetailListing === item.type
                  ? "before:w-full"
                  : "before:w-0"
              }`}
            ></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DetailSectionTabs;
